<template>
	<EventLayout :event="event" :subtitle="trans('events.mailing.title')">
		<template #actions>
			<select v-model="nextStatus" @change.stop="goToNextStatus">
				<option v-for="enrollmentStatus in EnrollmentStatus" :value="enrollmentStatus">{{ trans(`events.mailing.${enrollmentStatus}`) }}</option>
			</select>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
			<PrimaryButton :color="Color.Purple" @click.stop="send">
				<i class="fa-solid fa-paper-plane mr-2"/>
				{{ trans('general.send') }}
			</PrimaryButton>
			<a :href="route('events.enrollments.mailing.show', {event: event.id, status})" target="_blank">
				<PrimaryButton :color="Color.Blue">
					<i class="fa-solid fa-eye mr-2"/>
					{{ trans('general.preview') }}
				</PrimaryButton>
			</a>
		</template>
		<TextEditor v-model="mailText" bordered/>
	</EventLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {router} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import TextEditor from '@/Components/UI/Editor/TextEditor.vue'
import {EnrollmentStatus} from '@/Types/Enums/EnrollmentStatus'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
	status:string,
	mailText:string,
}>()

const event:Ref<Event> = ref(props.event)
const status:Ref<string> = ref(props.status)
const working:Ref<boolean> = ref(false)
const mailText:Ref<string> = ref(props.mailText)
const nextStatus:Ref<string> = ref(props.status)

function update():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.enrollments.mailing.update', [event.value.id, status.value]), {
			text: mailText.value,
		}).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}

function send():void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('tools.campaigns.mails.sending'))
		axios.post(route('events.enrollments.mailing.store', [event.value.id, status.value])).then(() => {
			showSuccess(trans('tools.campaigns.mails.sent'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}

function goToNextStatus():void{
	router.get(route('events.enrollments.mailing.index', {event: event.value.id, status: nextStatus.value}))
}
</script>